import styled from 'styled-components'

export const ActionBox = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;
  margin-top: 24px;

  > .input-wrapper {
    width: 100%;
    max-width: 450px;
  }

  > .button-wrapper {
    /* border: 1px solid red; */
  }

  @media (max-width: 780px) {
    flex-direction: column-reverse;
    flex-wrap: nowrap;
    margin-top: 16px;
    padding-bottom: 8px;

    > .input-wrapper {
      max-width: unset;
    }
  }
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const CardsWrapper = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;

  > .card-box {
    flex: 1;
    height: auto;
    min-height: 250px;
    min-width: 265px;
  }
`
